import React from 'react'
import styled from 'styled-components'
import WorkspaceSequence from '../../components/kiosk/KioskContent/WorkspacesSequence/WorkspacesSequence'
import {useUserState} from '../../context/UserContext'
import {useUIDispatch} from '../../context/UIContext'

const StyledContainer = styled.div`
  height: 100vh;
  width: 100vw;
  box-sizing: border-box;
`
const WorkspaceBooking = ({parentPage, roomCode, isQrView}) => {
  const {user} = useUserState()
  const uiDispatch = useUIDispatch()

  const onCancel = ({roomCode}) => {
    const {bl_id: blId, fl_id: flId, rm_id: rmId} = roomCode

    uiDispatch({
      type: 'showSearch',
      payload: {show: false, type: null, options: {}}
    })
    uiDispatch({
      type: 'setContent',
      payload: {content: parentPage, props: {blId, flId, rmId}}
    })
  }

  return (
    <StyledContainer>
      <WorkspaceSequence
        user={user}
        roomCode={roomCode}
        goToMain={onCancel}
        isQrView={isQrView}
        onCancel={onCancel}
      />
    </StyledContainer>
  )
}

export default WorkspaceBooking

WorkspaceBooking.defaultProps = {
  isQrView: false
}
